import React from 'react'
import Svg, { Path, SvgProps } from 'react-native-svg'

import { Color } from '../../style'

export interface Props extends SvgProps {}
const IconGraph = (props: Props) => {
  const { width, height, color, ...otherProps } = props
  return (
    <Svg
      width={width}
      height={height}
      viewBox={`0 0 ${IconGraph.dimensions.width} ${IconGraph.dimensions.height}`}
      {...otherProps}
    >
      <Path
        fill="none"
        stroke={color || Color.premiumBlack}
        strokeMiterlimit={10}
        strokeWidth={0.6}
        d="M4.785 5.976H.968v12.388h3.817V5.976ZM10.842 3.368H7.025v14.996h3.817V3.368ZM17.07.496h-3.817v17.868h3.817V.496ZM.53 20.504h16.94"
      />
    </Svg>
  )
}

IconGraph.dimensions = {
  width: 18,
  height: 21,
}

export default IconGraph
